export default __webpack_public_path__ + "static/media/inicio.af004828.jpg";